import cn from 'classnames';
import Image from 'next/image';

import PlaybackSvg from 'public/static/svg/playback.svg';

interface ArticlePremiumVideoCoverProps {
  className?: string;
  imageSrc?: string;
  imageAlt?: string;
  videoLockedLabel: string;
}
export default function ArticlePremiumVideoCover({
  className,
  imageSrc,
  imageAlt,
  videoLockedLabel,
}: ArticlePremiumVideoCoverProps) {
  return (
    <div className={cn('relative aspect-video w-full', className)}>
      <div className="aspect-video h-full w-full">
        <Image
          src={imageSrc || 'https://cdn-trans.info/uploads/2017/09/86d06cfc167f8e3f01657fde7eb-1024x684.jpg'}
          alt={imageAlt || ''}
          loading="lazy"
          width={1920}
          height={1080}
          className="aspect-video h-auto w-full scale-95 rounded-2xl blur"
        />
        <PlaybackSvg className="absolute left-1/2 top-1/2 h-32 w-32 -translate-x-1/2 -translate-y-1/2 blur lg:h-64 lg:w-64" />
      </div>

      <p className="absolute bottom-6 left-0 w-full rounded-md bg-orange-500 px-3 py-2 text-center text-white lg:bottom-12 lg:text-lg">
        {videoLockedLabel}
      </p>
    </div>
  );
}
